import { ReactNode } from 'react'

type SecondaryButtonProps = {
  testLocator?: string
  onClick: () => void
  label?: string
  children?: ReactNode
  secondaryButtonClassName?: string
  isDisabled?: boolean
  isActive?: boolean
}

export const SecondaryButton = ({
  onClick,
  label,
  secondaryButtonClassName,
  children,
  isDisabled,
  isActive,
  testLocator
}: SecondaryButtonProps) => {
  return (
    <button
      test-locator={testLocator}
      className={`text-[#232323] ${isActive ? 'bg-[#F0F4F7]' : 'bg-white'} rounded-[12px] h-[48px] w-full border border-solid border-[#F0F4F7] 
       focus:outline-none hover:border hover:border-solid hover:border-[#F0F4F7] font-[500] text-[14px] text-center flex items-center justify-center ${secondaryButtonClassName ?? ''}`}
      onClick={onClick}
      disabled={isDisabled}
    >
      <div className={`${isDisabled ? 'opacity-20' : ''}`}>{children ?? label}</div>
    </button>
  )
}
